import { createSlice } from '@reduxjs/toolkit'

import { IProfile, TTimeAirDrop } from '@/redux/api/profile/profile.type'

import { IBuySell } from '../web3/web3.type'

const initialState = {
  loading: false,
  isBuySell: '',
  dataBuySell: {
    buyPrice: 0,
    buyPriceInfluFee: 0,
    buyPriceSightFee: 0,
    buyPriceWithFee: 0,
    buyTransactionFee: 0,
    sellPrice: 0,
    sellPriceInfluFee: 0,
    sellPriceSightFee: 0,
    sellPriceWithFee: 0,
    sellTransactionFee: 0,
    totalSupply: 0,
  } as IBuySell,
  nextUser: {} as IProfile,
  airDrop: {} as TTimeAirDrop,
  userBuySell: { avatar: '', name: '', key: '', keyPrice: 0, type: '', idUser: '' },
  isModal: '',
}

const BuySellSlice = createSlice({
  name: 'buysell',
  initialState,
  reducers: {
    setBuySell: (state, action) => {
      state.isBuySell = action.payload
    },
    setData: (state, acton) => {
      state.dataBuySell = acton.payload
    },
    setNextUser: (state, aciton) => {
      state.nextUser = aciton.payload
    },
    setAirDrop: (state, aciton) => {
      state.airDrop = aciton.payload
    },
    setUserBuySell: (state, action) => {
      state.userBuySell = action.payload
    },
    setIsModal: (state, action) => {
      state.isModal = action.payload
    },
  },
  extraReducers: () => {},
})

export const BuySellActions = BuySellSlice.actions
const buysellReducer = BuySellSlice.reducer
export default buysellReducer
